<template lang="pug">
UiCardSection(padding="xl")
  h4 {{ $t("companies.tabs.basic") }}
  .form-container
    UiFormGroup(:label="$t('companies.basic.name')")
      UiInput(v-model="company.company_name")

    UiFormGroup(:label="$t('companies.basic.netvisor_organization_id')")
      UiInput(v-model="company.netvisor_organization_id")

    UiFormGroup(
      :label="$t('companies.basic.email')"
      :vuelidateModel="v$.company.email"
    )
      UiInput(
        v-model="company.email"
        :error="v$.company.email.$error"
      )

    UiFormGroup(:label="$t('companies.basic.reseller')")
      UiMultiselect(
        v-model="company.reseller_id"
        :options="resellersOptions"
        :canClear="false"
        :canDeselect="false"
        label="text"
      )

    UiFormGroup
      UiStack
        UiStackItem
          UiButton(
            @click="downloadServiceAgreementFile()"
            icon="Download"
          ) {{ $t("actions.download_service_agreement") }}
        UiStackItem(fill)
        UiStackItem
          UiButton(
            :disabled="v$.$error"
            @click="save()"
            icon="Check"
          ) {{ $t("actions.save") }}
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import { email } from "@vuelidate/validators";
import _isEmpty from "lodash/isEmpty";
import ApiCompanies from "@/api/companies.js";
import ApiResellers from "@/api/resellers.js";

export default {
  data() {
    return {
      company: {},
      resellers: [],
    };
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  computed: {
    resellersOptions() {
      return this.resellers.filter((reseller) => reseller.value);
    },
  },

  mounted() {
    this.getData();
  },

  validations() {
    return {
      company: {
        email: { email },
      },
    };
  },

  methods: {
    getData() {
      ApiResellers.fetchResellers({
        sortBy: "name",
        per_page: 9999,
      }).then((resp) => {
        this.resellers = resp.data.resellers.map((res) => {
          return { value: res.id, text: res.name };
        });
        ApiCompanies.getCompany(this.$route.params.id)
          .then((resp) => {
            this.company = resp.data.company;
          })
          .catch((e) => {
            if (
              !_isEmpty(e.response) &&
              !!e.response.status &&
              e.response.status === 403
            ) {
              this.$router.push({ name: "Companies" });
            }
          });
      });
    },

    async save() {
      try {
        const isFormCorrect = await this.v$.$validate();
        if (!isFormCorrect) {
          return;
        }

        ApiCompanies.updateCompany(this.company.id, this.company).then(
          (resp) => {
            this.company = resp.data.company;
          },
        );
      } catch {}
    },

    downloadServiceAgreementFile() {
      ApiCompanies.downloadServiceAgreementFile(this.$route.params.id)
        .then((resp) => {
          let fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "maintenance_contract.pdf");
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch(() => {});
    },
  },
};
</script>
